import dayjs from 'dayjs';

import { getPlannerDatesWindow } from '../../helpers/date';

/**
 * Pure builders for the horizontal dates window. Window-size invariants
 * (clamping to MAX_DATES_WINDOW vs deliberate expansion) live in the
 * dates-navigation slice — these helpers only build sequential date arrays.
 */

export const buildSequentialDates = (startDate: dayjs.Dayjs, days: number): dayjs.Dayjs[] =>
  Array.from({ length: days }, (_, i) => startDate.add(i, 'day'));

export const prependDates = (windowDates: dayjs.Dayjs[], days: number): dayjs.Dayjs[] => [
  ...buildSequentialDates(windowDates[0].subtract(days, 'day'), days),
  ...windowDates,
];

export const appendDates = (windowDates: dayjs.Dayjs[], days: number): dayjs.Dayjs[] => [
  ...windowDates,
  ...buildSequentialDates(windowDates[windowDates.length - 1].add(1, 'day'), days),
];

/**
 * Initial dates window: fixed MAX_DATES_WINDOW days centered on today.
 * Navigation actions must regenerate the same window size to keep the planner
 * scrollbar geometry consistent with scroll-driven pagination.
 */
export const getInitialPlannerDates = (): dayjs.Dayjs[] => getPlannerDatesWindow(dayjs());
